<template>
    <div class="justify-around">
        <div v-if="!fileId" style="width: 150px;overflow-y: scroll;background: #fff">
            <div v-for="bim of bimList" :key="bim.fileId" style="border-bottom: solid 1px gray"
                class="pointer flex"
            >
                <el-popover placement="right" trigger="hover" popper-class="monitor-popper-class">
                    <el-button size="mini" type="primary" icon="el-icon-share" @click="createQR(bim)"></el-button>
                    <div slot="reference" style="width: 150px;text-align: left" class="text-ellipsis"
                        :class="[selectedBim.name !== bim.name ? $style.bim : $style.selectedBim]" @click="selectedBim = bim"
                    >
                        {{ bim.name }}
                    </div>
                </el-popover>
            </div>
        </div>
        <div id="bim" style="width: 100%;height: 90.7vh"></div>
        <el-dialog :visible.sync="showQrcode" width="450px">
            <vue-qrcode :value="url" :options="{ width: 400 }"></vue-qrcode>
        </el-dialog>
    </div>
</template>

<script>
import util from '../../untils/util';
import myHttp from '../../untils/port';
import loadJs from '../../untils/loadJs';
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    name: 'BIMPaper',

    components: { VueQrcode },

    data() {
        return {
            projectId: util.session.get("groupId"),
            bimList: [
                { name: '1#门诊医技楼-土建结构', fileId: '10000799526307' },
            ],
            viewToken: '',
            dic: {
                '1534350540559794178': {
                    bimList:[
                        { name: '1#门诊医技楼-土建结构', fileId: '10000799526307' }
                    ],
                },
                'saoma': { width: '100vw' },
                'shuru': { width: 'calc(97vw - 150px)' },
            },
            app: undefined,
            viewer3D: undefined,
            showQrcode: false,
            url: '',
        }
    },

    computed: {
        selectedBim() {
            return this.dic[this.projectId]?.bimList[0];
        }
    },

    watch: {
        selectedBim() {
            if (this.app) this.app.destroy();
            this.getViewToken();
        },
    },

    mounted() {
        this.getViewToken();
    },

    methods: {
        createQR(bim) {
            this.showQrcode = true;
            this.url = `https://sitesweb.tongsheng01.com/wisdom/showbim?projectId=${this.projectId}&fileId=${bim.fileId}`;
            // this.url = `http://192.168.0.170:8081/wisdom/showbim?projectId=${this.projectId}&fileId=${bim.fileId}`;
            // window.open(this.url);
        },
        getViewToken() {
            myHttp.getViewToken({ projectId: this.projectId, fileId: this.selectedBim?.fileId }).then(res => {
                if (res.data.code === 200) this.showBIM(res.data.data);
                else this.$message.error(res.data.msg);
            });
        },
        showBIM(viewToken) {
            loadJs('https://static.bimface.com/api/BimfaceSDKLoader/BimfaceSDKLoader@latest-release.js')
                .then(() => {
                    let loaderConfig = new BimfaceSDKLoaderConfig();
                    loaderConfig.viewToken = viewToken;
                    BimfaceSDKLoader.load(loaderConfig, () => {
                        const element = document.getElementById('bim');
                        const webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
                        webAppConfig.domElement = element;
                        this.app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
                        this.app.addView(viewToken);
                        this.viewer3D = this.app.getViewer();
                        this.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, () => {
                            window.addEventListener('resize', () => this.viewer3D.resize(window.innerWidth, window.innerHeight));
                            this.viewer3D.render();
                        });
                    });
                });
        },
    },
}
</script>

<style lang="less" module>
.bim {
    padding: 10px 0;
    font-size: 18px;
    &:hover {
        background: #eee;
    }
}

.selectedBim {
    .bim();
    color: #5A87F9;
    background: #E7F1FB;
}
</style>

<style lang="less">
.monitor-popper-class {
    min-width: 80px;
    padding: 4px 4px;
    display: flex;
    justify-content: center;
}
</style>
